export default __webpack_public_path__ + "static/media/iconvariation (1).6ec747f5.svg";